import React, { useState } from "react";
import "./Checkbox.css";
import { AutoCompleteValue } from "../InputForm/InputForm";

const Checkbox = ({ id, title, checked, onChange, style = null }) => {
  return (
    <div className="cs-checkbox-container">
      <input
        autoComplete={AutoCompleteValue}
        placeholder={""}
        value={""}
        checked={checked}
        onChange={(val: any) => {
          let value = val.target.checked;
          onChange(id, value);
        }}
        type="radio"
        name={id}
        className="cs-checkbox"
      />
      <span style={{ marginLeft: "12px", ...style }}>{title}</span>
    </div>
  );
};

export default Checkbox;
